import React from 'react';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { CookiesProvider } from 'react-cookie';
import coreTheme from '../core/styles/theme';

import Layout from './Layout';
import Home from './Home';
import Form from './Form';
import NotFound from './NotFound';
import NotAuthorized from './NotAuthorized';
import { PreferencesProvider } from '../core/context/PreferencesContext';
import useTitle from '../core/api/hooks/common/useTitle';

const queryClient = new QueryClient();

function Root() {
  useTitle(document.documentURI);
  return (
    <BrowserRouter>
      <CookiesProvider>
        <PreferencesProvider>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={coreTheme}>
                <QueryClientProvider client={queryClient}>
                  <Routes>
                    <Route path="/" element={<Layout />}>
                      <Route index element={<Home />} />
                      <Route path="form/*" element={<Form />} />
                    </Route>

                    <Route path="not-authorized" element={<NotAuthorized />} />

                    {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  <ReactQueryDevtools initialIsOpen />
                </QueryClientProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </PreferencesProvider>
      </CookiesProvider>
    </BrowserRouter>
  );
}

export default Root;
